// Safer mega menu "More/Less" toggle (no .closest on non-elements)
(function () {
  function getClosest(el, selector) {
    // Walk up until we find a parent that matches selector
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function initMegaMore() {
    // If you're using inline buttons (no delegation), you can skip this and attach per-button
    document.addEventListener('click', function (e) {
      var target = e.target;

      // If not an Element (e.g., Text node), normalize to parentElement
      if (!target || target.nodeType !== 1) {
        target = target && target.parentElement ? target.parentElement : null;
      }
      if (!target) return;

      var btn = getClosest(target, '.megamenu__more');
      if (!btn) return; // Click was not on a More/Less button

      e.preventDefault();

      var listId = btn.getAttribute('aria-controls');
      var list = listId ? document.getElementById(listId) : null;
      if (!list) return;

      var items = list.querySelectorAll(':scope > .navigation__item');
      if (items.length <= 10) {
        btn.style.display = 'none';
        return;
      }

      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var next = !expanded;

      btn.setAttribute('aria-expanded', next ? 'true' : 'false');
      list.setAttribute('aria-expanded', next ? 'true' : 'false');
      btn.textContent = next ? 'Less' : 'More';
    });

    // Initialize default state for all lists/buttons
    var buttons = document.querySelectorAll('.megamenu__more');
    buttons.forEach(function (btn) {
      var listId = btn.getAttribute('aria-controls');
      var list = listId ? document.getElementById(listId) : null;
      if (!list) return;

      var items = list.querySelectorAll(':scope > .navigation__item');
      if (items.length <= 10) {
        btn.style.display = 'none';
        return;
      }

      list.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = 'More';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMore);
  } else {
    initMegaMore();
  }
  setTimeout(initMegaMore, 500);
})();
